import { Autocomplete, TextField } from "@mui/material";
import React, { useState } from "react";
import { connect } from "react-redux";
import { setLocale } from "../../../../ducks/entity";

const locales = [
  { id: "en", name: "English" },
  { id: "cy", name: "Cymraeg" },
  { id: "fr", name: "French" },
  { id: "de", name: "German" },
  { id: "hu", name: "Hungarian" },
  { id: "it", name: "Italian" },
  { id: "pt", name: "Portuguese" },
  { id: "es", name: "Spanish" },
];

const LanguageSelector = ({ language, setLocale }) => {
  const [selected, setSelected] = useState(
    locales.find((locale) => locale.id === language) || locales[0],
  );

  const handleLanguageChange = (_, value) => {
    setSelected(value);
    setLocale(value.id);
  };

  return (
    <Autocomplete
      id="selectLanguage"
      options={locales}
      getOptionLabel={(option) => option.name || ""}
      renderInput={(params) => (
        <TextField
          data-testid="t-Languag-search"
          {...params}
          variant="outlined"
          label="Language"
          placeholder="Search"
          className="exclude-from-focus"
        />
      )}
      onChange={handleLanguageChange}
      value={selected}
      disableClearable={true}
    />
  );
};

const mapStateToProps = ({ entity }) => ({
  language:
    entity.selectedLocale ||
    locales.find((locale) => locale.name === entity.language)?.id,
});

const mapDispatchToProps = (dispatch) => ({
  setLocale: (locale) => dispatch(setLocale(locale)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelector);
